<div class="list-item">
  <div class="row">
    <div class="col-10">
      <label class="">
        <input
          class="{{ viewName }}-check"
          type="checkbox"
          [checked]="selected"
          (change)="select(item, selected)"
        />
        {{ item.description }}
      </label>
    </div>
    <div class="col-2 list-item-icon">
      <div *ngIf="item.children.length; else quantityBlock">
        <a
          data-toggle="collapse"
          href="#box{{ item.id }}"
          class="panel-heading collapsed"
        ></a>
      </div>
      <ng-template #quantityBlock>
        <span class="badge badge-secondary">{{ item.quantity }}</span>
      </ng-template>
    </div>
  </div>
  <div
    id="box{{ item.id }}"
    class="box{{
      item.id
    }} pl-3 list-group list-group-flush panel-collapse collapse"
  >
    <app-catalog-menu
      #submenu
      [selected]="item.selected"
      (onSelect)="onChildrenSelected($event)"
      *ngFor="let item of item.children"
      [item]="item"
      [viewName]="item.description + ' ' + this.viewName"
    ></app-catalog-menu>
  </div>
</div>
